var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM17.4109 14.9014C17.4873 14.5151 17.0552 14.2554 16.6983 14.4219C15.7474 14.8656 14.0323 15.5 12 15.5C9.96769 15.5 8.25259 14.8656 7.30165 14.4219C6.9448 14.2554 6.51266 14.5151 6.58913 14.9014C7.01256 17.0401 8.92879 19 12 19C15.0712 19 16.9874 17.0401 17.4109 14.9014ZM7.25 11C7.25 10.3096 7.80964 9.75 8.5 9.75C9.19036 9.75 9.75 10.3096 9.75 11C9.75 11.4142 10.0858 11.75 10.5 11.75C10.9142 11.75 11.25 11.4142 11.25 11C11.25 9.48122 10.0188 8.25 8.5 8.25C6.98122 8.25 5.75 9.48122 5.75 11C5.75 11.4142 6.08579 11.75 6.5 11.75C6.91421 11.75 7.25 11.4142 7.25 11ZM14.25 11C14.25 10.3096 14.8096 9.75 15.5 9.75C16.1904 9.75 16.75 10.3096 16.75 11C16.75 11.4142 17.0858 11.75 17.5 11.75C17.9142 11.75 18.25 11.4142 18.25 11C18.25 9.48122 17.0188 8.25 15.5 8.25C13.9812 8.25 12.75 9.48122 12.75 11C12.75 11.4142 13.0858 11.75 13.5 11.75C13.9142 11.75 14.25 11.4142 14.25 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperHappy);
export default __webpack_public_path__ + "static/media/super-happy.7b0556088fb53a19becc14d0e3af5d81.svg";
export { ForwardRef as ReactComponent };